import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../redux/slices/language";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGetSettings } from "../../hooks/useGetSettings";
import { useGetServices } from "../../hooks/services/useGetServices";
import i18next from "i18next";
import { Dropdown } from "react-bootstrap";
import DataLoader from "../DataLoader";

export default function NavBar() {
  const { t } = useTranslation();
  useGetSettings();
  const { services } = useGetServices();

  const { lang } = useSelector((state) => state.language);

  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const [menuOpen, setMenuOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isChangingLang, setIsChangingLang] = useState(false);

  const handleLang = async (newLang) => {
    setIsChangingLang(true); // Show loader overlay
    dispatch(setLanguage(newLang)); // Updates Redux & LocalStorage
    await i18next.changeLanguage(newLang); // Updates static text
    await queryClient.invalidateQueries(); // Waits for new translated data
    setIsChangingLang(false); // Hide loader overlay
  };

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);

  const loaderPortal = createPortal(
    isChangingLang && <DataLoader />,
    document.body
  );

  const mobileMenu = createPortal(
    <>
      <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
        <li className="close-btn-li">
          <button className="close-menu-btn" onClick={closeMenu}>
            <i className="fa-light fa-xmark"></i>
          </button>
        </li>
        <li>
          <NavLink to="/" onClick={closeMenu}>
            {t("home")}
          </NavLink>
        </li>
        <li>
          <NavLink to="/about" onClick={closeMenu}>
            {t("about")}
          </NavLink>
        </li>
        <li>
          <NavLink to="/packages" onClick={closeMenu}>
            {t("packages")}
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/services"
            className="nav-link"
            onClick={closeMenu}
          >
            {t("services")}
          </NavLink>
        </li>
        <li>
          <NavLink to="/portfolio" onClick={closeMenu}>
            {t("portfolio")}
          </NavLink>
        </li>
        <li>
          <NavLink to="/blogs" onClick={closeMenu}>
            {t("blogs")}
          </NavLink>
        </li>
        <li>
          <NavLink to="/contact" onClick={closeMenu}>
            {t("contact")}
          </NavLink>
        </li>
      </ul>
      <div
        className={`layer ${menuOpen ? "active" : ""}`}
        onClick={closeMenu}
      ></div>
    </>,
    document.body
  );

  return (
    <nav className="container">
      <Link to="/" className="logo">
        <img src="/images/anan-logo.png" alt="ANAN TEC" />
      </Link>

      {/* Desktop nav links */}
      <ul className="nav-links desktop-nav">
        <li>
          <NavLink to="/">{t("home")}</NavLink>
        </li>
        <li>
          <NavLink to="/about">{t("about")}</NavLink>
        </li>
        <li>
          <NavLink to="/packages">{t("packages")}</NavLink>
        </li>

        <li>
          <Dropdown
            show={isOpen}
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
            style={{ position: "relative" }}
          >
            <NavLink
              to="/services"
              className="nav-link dropdown-toggle"
              onClick={() => setIsOpen(false)}
            >
              {t("services")}
            </NavLink>
            <Dropdown.Menu align="start">
              <div className="scroll_menu">
                {services?.map((service) => (
                  <Dropdown.Item
                    key={service?.id}
                    as={Link}
                    to={`/services/${service?.id}`}
                    onClick={() => setIsOpen(false)}
                  >
                    {service?.title}
                  </Dropdown.Item>
                ))}
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </li>
        <li>
          <NavLink to="/portfolio">{t("portfolio")}</NavLink>
        </li>
        <li>
          <NavLink to="/blogs">{t("blogs")}</NavLink>
        </li>
        <li>
          <NavLink to="/contact">{t("contact")}</NavLink>
        </li>
      </ul>

      {/* Loader Portal */}
      {loaderPortal}

      {/* Mobile menu via Portal */}
      {mobileMenu}

      <div className="actions">
        <Link to="/contact" className="nav-brief-link">
          {t("startProject") || "ابدأ مشروعك"}
        </Link>
        <button onClick={() => handleLang(lang === "en" ? "ar" : "en")}>
          {lang === "en" ? "AR" : "EN"}
        </button>
        <button className="menu-button" onClick={toggleMenu}>
          <i className="fa-light fa-bars"></i>
        </button>
      </div>
    </nav>
  );
}
